export enum OnboardingDialogStep {
  Onboarding = "Onboarding",
  Login = "Login",
  Register = "Register",
  ForgotSecret = "ForgotSecret",
  // Add post login info AFTER register
  AddBankAccount = "AddBankAccount",
  AddLegalName = "AddLegalName",
  AddBankLegalName = "AddBankLegalName",
  // Update post login info AFTER login
  UpdateBankAccount = "UpdateBankAccount",
  UpdateLegalName = "UpdateLegalName",
  UpdateBankLegalName = "UpdateBankLegalName",
}
